import { create } from "zustand";
import { persist } from "zustand/middleware";

interface Player {
  id: number;
  username: string;
  displayName: string;
  email: string;
  currentLeagueId?: number;
  totalPoints: number;
  preferredLanguage?: "en" | "de";
}

interface AuthState {
  player: Player | null;
  token: string | null;
  isAuthenticated: boolean;
  login: (player: Player, token: string) => void;
  logout: () => void;
  updatePlayer: (player: Player) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      player: null,
      token: null,
      isAuthenticated: false,
      login: (player: Player, token: string) => {
        set({
          player,
          token,
          isAuthenticated: true,
        });
      },
      logout: () =>
        set({
          player: null,
          token: null,
          isAuthenticated: false,
        }),
      updatePlayer: (player: Player) =>
        set((state) => ({
          ...state,
          player,
        })),
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        player: state.player,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
